export default {
  p: {
    marginTop: 0
  },
  'h1, h2, h3, h4, h5, h6': {
    fontWeight: 300,
    marginBottom: '2.0rem',
    marginTop: 0
  },
  h1: {
    fontSize: '4.0rem',
    letterSpacing: '-.1rem',
    lineHeight: 1.2
  },
  h2: {
    fontSize: '3.6rem',
    letterSpacing: '-.1rem',
    lineHeight: 1.25
  },
  h3: {
    fontSize: '3.0rem',
    letterSpacing: '-.1rem',
    lineHeight: 1.3
  },
  h4: {
    fontSize: '2.4rem',
    letterSpacing: '-.08rem',
    lineHeight: 1.35
  },
  h5: {
    fontSize: '1.8rem',
    letterSpacing: '-.05rem',
    lineHeight: 1.5
  },
  h6: {
    fontSize: '1.6rem',
    letterSpacing: 0,
    lineHeight: 1.4
  }
}



// WEBPACK FOOTER //
// ./src/assets/globalStyles/typography.js